import './startOnBoot'
import './machineIfcontrol'

import './machineIfzeroLed'
import './machineIfzeroButton'
import './machineIfzeroGpioButton'
import './machineIfzeroBmpGet'
import './machineIfzeroMpuGet'
import './machineIfzeroRgbLedPin'
import './machineIfzeroRgbLed'
import './machineIfzeroPhotoresistor'
import './machineIfzeroBuzzer'
import './machineIfzeroUltrasonic'
import './machineIfzeroLcdPin'
import './machineIfzeroLcdPrint'
import './machineIfzeroLcdControl'
import './machineIfzeroLcdCursor'
import './machineIfzeroLcdChar'
import './machineIfzeroTempHum'
import './machineIfzeroServo'
import './machineIfzeroBatteryGet'
import './timeSleep'
import './commonColor'

import './machineIflineMotor'
import './machineIflineMotorSpeed'
import './machineIflineDistanceGet'
import './machineIflineIrGet'
import './machineIflineMortorIrReset'
import './machineIflineMortorIrGet'
import machineIflineLed from './machineIflineLed'

export default {
  setIflineLedImageUrl: machineIflineLed.setImageUrl
}
